export default {
  activity_energy_01: {
    title: 'Jeg reduserte innetemperaturen i dag',
    description:
      'Kan logges på dager du har senket innetemperaturen 2 grader mindre enn normalt, eller hvis du bare varmer opp deler av hjemmet ditt. For å logge aktiviteten hver dag er det nok at du reduserer temperaturen èn gang. Du trenger ikke å redusere temperaturen ytterligere 2 grader hver gang du logger aktiviteten.',
    co2_explanation: `MARKDOWN:
## Fakta
- En gjennomsnittlig norsk husholdning holder en snitt-temperatur på 22 grader og når dette reduseres med 2 grader reduseres energiforbruket med 13%. Ved å senke innetemperaturen eller unngå å varme opp rom som ikke brukes, bidrar du til lavere klimagassutslipp gjennom energibesparelse.

## Hva vi antar
- I beregningene antas det at du bor i et gjennomsnittlig hus med en typisk familie, og gjennomsnittlig oppvarming. Innsparingen beregnes basert på innsparingspotensiale for å redusere innendørstemperaturen med 2 grader. 
- Mengden utslipp per kWh beregnes fra elektrisitet, fjernvarm, fyring og olje. 
- Energimiksen til ditt land eller region er en del av beregningene, og effekten av handlingen kan avvike betydelig mellom regioner.
`,
    health_explanation: `MARKDOWN:
## Fakta
- Å redusere innendørstemperaturen er bra for helse og velvære, og hjelper deg å oppnå termisk komfort. Dette fordi høy innendørstemperatur kan gjøre at du føler deg sliten og mindre aktiv, men lav temperatur kan gjøre at du føler deg kald og rastløs.

## Tilleggsinformasjon
- [https://www.greeneducationfoundation.org/green-building-program-sub/learn-about-green-building/1239-thermal-comfort.html](https://www.greeneducationfoundation.org/green-building-program-sub/learn-about-green-building/1239-thermal-comfort.html)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_02: {
    title: 'Jeg reduserte natt-temperaturen',
    description:
      'Kan logges på netter hvor innetemperaturen er minst 2 grader mindre enn dagtemperaturen.',
    co2_explanation: `MARKDOWN:
## Fakta
- Å redusere innendørstemperaturen på natten sparer energi sammenlignet med å holde en konstant temperatur.

## Hva vi antar
- I beregningene antas det at du bor i et gjennomsnittlig hus med en typisk familie, og gjennomsnittlig oppvarming. Innsparingen beregnes basert på innsparingspotensiale for å redusere innendørstemperaturen med 2 grader 8 timer hver natt. 
- Mengden utslipp per kWh beregnes fra elektrisitet, fjernvarm, fyring og olje. 
- Energimiksen til ditt land eller region er en del av beregningene, og effekten av handlingen kan avvike betydelig mellom regioner.
`,
    health_explanation: `MARKDOWN:
## Fakta
- Å redusere innendørstemperaturen er bra for helse og velvære.
`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_03: {
    title: 'Jeg slo av unødvendig lys i dag',
    description:
      'Kan logges på dager hvor du slår av lysene hjemme når de ikke er i bruk.',
    co2_explanation: `MARKDOWN:
## Fakta
- Å tilegne seg en vane for å slå av unødvendig lys sparer ikke bare energi, men også penger.
- Det gjør også at man blir mer bevisst ressurserne man bruker og kan påvirke holdninger på flere områder.

## Hva vi antar
- Beregningene baseres på at vi i gjennomsnitt bruker omtrent 500 kWh på lys hvert år, og at man kan spare 70% strøm på å skru av lys man ikke bruker.
`,
    health_explanation: `MARKDOWN:
## Fakta
- Eksponering for lys på natten antas å påvirke søvnen din, og kan være en risiko for helseproblemer som diabetes.

## Tilleggsinformasjon
- [https://www.netdoctor.co.uk/healthy-living/wellbeing/a10639/how-light-affects-your-health/](https://www.netdoctor.co.uk/healthy-living/wellbeing/a10639/how-light-affects-your-health/)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_04: {
    title: 'Jeg reduserte oppvaskmengden i dag',
    description:
      'Kan logges på dager hvor du reduserer antall ganger du trenger å kjøre oppvaskmaskinen ved å bruke færre drikkeglass, kopper, asjetter osv. eller sørger for at oppvaskmaskinen er full når du kjører den.',
    co2_explanation: `MARKDOWN:
## Fakta
- Å bruke en energieffektiv oppvaskmaskin sparer energi, vann og CO₂e-utslipp.

## Hva vi antar
- I beregningene antas det at du kan spare omtrent 50% av gjennomsnittlig energiforbruk på å redusere oppvaskmengden og kun kjøre fulle oppvaskmaskiner. 

## Tilleggsinformasjon
- [https://www.greenchoices.org/green-living/at-home/is-it-greener-to-hand-wash-or-use-a-dishwasher](https://www.greenchoices.org/green-living/at-home/is-it-greener-to-hand-wash-or-use-a-dishwasher)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_05: {
    title: 'Jeg lufttørket klær i dag',
    description:
      'Kan logges på dagen du vasker klær og henger opp tøyet på klesstativ i stedet for å tørke klærne i tørketrommelen.',
    co2_explanation: `MARKDOWN:
## Fakta
- Tørketrommelen er et av apparatene i husholdningen med høyest watt-effekt, og forbruker nest mest energi, etter kjøleskapet. Ved å henge klesvasken til tørk i stedet for å tromle den, bidrar du til at vi kan takle en økende befolkningsvekst uten å bygge ut mer kraftproduksjon.

## Hva vi antar
- Beregningene er gjort ved å fjerne ditt utslipp fra tromling. Det antas at du bruker like mye energi på tromling som en gjennomsnittlig husholdning per dag.

## Tilleggsinformasjon
- [https://www.cleancult.com/blog/8-reasons-why-you-should-air-dry-your-clothes/](https://www.cleancult.com/blog/8-reasons-why-you-should-air-dry-your-clothes/)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_06: {
    title:
      'Jeg trakk ut kontakten på alle elektriske apparater som ikke var i bruk i dag.',
    description:
      'Kan logges hvis du i løpet av en dag kobler fra elektroniske enheter som ikke brukes (det kan være TV-er, ladere, spillkonsoller osv.)',
    co2_explanation: `MARKDOWN:
## Fakta 
- De fleste av oss kjenner til de store strømslukene, men det finnes også noen små grep som kan bidra til å spare mye strøm. Trekk ut kontakten på elektriske apparater som TV, ladere, datamaskiner, skjermer, spillkonsoler og stereoanlegg når de ikke brukes. Disse trekker unødvendig strøm når de står i standby-modus og bare venter på å bli brukt.

## Hva vi antar
- Vi antar at ved å koble ute dingser som ikke er bruk kan du redusere strømforbruken av dingser med ca 30%

## Tilleggsinformasjon
- [https://www.aol.com/2011/06/20/12-household-appliances-you-should-unplug-to-save-money/?guccounter=1](https://www.aol.com/2011/06/20/12-household-appliances-you-should-unplug-to-save-money/?guccounter=1)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_07: {
    title: 'Jeg unngikk bruk av elektroniske enheter i kveld',
    description:
      'Kan logges på dager du planlegger å ha en kveld uten elektroniske enheter (det kan være TV-er, ladere, spillkonsoller osv.) mellom 17:00 og 23:00.',
    co2_explanation: `MARKDOWN:
## Fakta
- Å ikke bruke elektronikk sparer energi, penger og CO₂e-utslipp. 

## Hva vi antar
- I beregningene antas det at du bruker samme mengde elektronikk som en gjennomsnittlig person i ditt land, og at 15% av dette brukes på underholdning.
- Beregningene antar at strømforbruket ditt reduseres med 80%.`,
    health_explanation: `MARKDOWN:
## Fakta
- Å unngå elektronikk på kveldstid kan bedre nattesøvnen. En god natts søvn forsterker hukommelse, læring, og du blir mer organisert og avslappet.

## Tilleggsinformasjon
- [https://www.psychologytoday.com/us/blog/mental-wealth/201103/wired-and-tired-electronics-and-sleep-disturbance-in-children](https://www.psychologytoday.com/us/blog/mental-wealth/201103/wired-and-tired-electronics-and-sleep-disturbance-in-children)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_08: {
    title: 'Jeg har dusjet i 5 minutter eller kortere i dag',
    description:
      'Kan logges på dager hvor du dusjer i 5 minutter eller mindre. Du kan time det ved å bruke favorittsangen din.',
    co2_explanation: `MARKDOWN:
## Fakta 
- Ved å dusje sjeldnere og kutte ned på dusjtiden sparer du energi, vann og CO₂e-utslipp. Du kan også nyte en lavere strømregning og sitte litt lengre ved frokostbordet om morgenen! 

## Hva vi antar
- Det antas at et dusjhode har en gjennomstrømning på omtrent 9,5 liter med vann per minutt og at en dusj varer i omtrent 8 minutter.
- Beregningene er basert på at du sparer energien som kreves for å varme opp 30 liter vann ved å gjøre denne aktiviteten.

## Tilleggsinformasjon
- [https://www.theguardian.com/commentisfree/2016/mar/08/shower-once-a-week-polluting-environment](https://www.theguardian.com/commentisfree/2016/mar/08/shower-once-a-week-polluting-environment)`,
    health_explanation: `MARKDOWN:
## Fakta
- Å dusje hver dag kan være dårlig for huden din, men mange dusjer minst en gang om dagen. Overforbuk av såpe er blant det som kan bidra til å strippe huden for dens naturlige oljer. Å dusje mindre kan derfor bidra til å forbedre hudens helse.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_09: {
    title: 'Jeg vasket meg med klut i stedet for å dusje i dag',
    description:
      'Kan logges på dager hvor du i stedet for å bruke badekar eller dusj tar en kroppsvask ved vasken.',
    co2_explanation: `MARKDOWN:
## Fakta 
- En kattevask kan bidra til å spare energi, mindre forurensning, bedre økonomi og bedre beskyttelse av huden din.

## Hva vi antar
- Det antas at et dusjhode har en gjennomstrømning på omtrent 9,5 liter med vann per minutt og at en dusj varer i omtrent 8 minutter.
- En kattevask antas å være det samme som et minutt med dusjing. 
- Beregningene er basert på at energien som kreves for å varme opp 65 liter vann spares på å gjøre denne aktiviteten.

## Tilleggsinformasjon
- [https://www.theguardian.com/commentisfree/2016/mar/08/shower-once-a-week-polluting-environment](https://www.theguardian.com/commentisfree/2016/mar/08/shower-once-a-week-polluting-environment)`,
    health_explanation: `MARKDOWN:
## Fakta
- Å dusje hver dag kan være dårlig for huden din, men mange dusjer minst en gang om dagen. Overforbuk av såpe er blant det som kan bidra til å strippe huden for dens naturlige oljer. Å dusje mindre kan derfor bidra til å forbedre hudens helse.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_10: {
    title: 'Jeg har brukt mindre varmtvann fra krana i dag',
    description:
      'Kan logges på dagene du bruker kaldt vann eller reduser mengden varmtvann for å pusse tennene, vaske hendene, barbere deg, vaske opp osv.',
    co2_explanation: `MARKDOWN:
## Fakta 
- Å bruke mindre varmtvann fra springen sparer vann, energi og reduserer CO₂e-utslipp.

## Hva vi antar
- I beregningen antas det at omrent 15% av gjennomsnittlig varmtvannsforbruk brukes på annet forbruk enn dusjing og at 70% kan spares ved å gjennomføre denne aktiviteten.

## Tilleggsinformasjon
- [https://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.828.2626&rep=rep1&type=pdf](https://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.828.2626&rep=rep1&type=pdf)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_11: {
    title:
      'Jeg gjenbrukte klærne mine ELLER fylte vaskemaskinen helt full i dag',
    description:
      'Kan logges på dager du reduserer behovet for å vaske klær. Du kan bruke klær på nytt eller sørge for at du fyller opp vaskemaskinen før du setter den på.',
    co2_explanation: `MARKDOWN:
## Fakta
- Å vaske og tromle 5 kg med klær annenhver dag i ett år har et utslipp på 440 kg CO₂e. Bruker du klærne dine litt lengre før de vaskes, og bare kjører fulle vaskemaskiner bidrar du til lavere klimagassutslipp.

## Hva vi antar
- Det antas at du kan spare omtrent 50% av gjennomsnittlig energiforbuk på å samle opp klær og vaske sjeldnere.

## Tilleggsinformasjon
- [https://theswatchbook.offsetwarehouse.com/2015/07/16/environmental-impact-of-the-washing-machine/](https://theswatchbook.offsetwarehouse.com/2015/07/16/environmental-impact-of-the-washing-machine/)`,
    health_explanation: `MARKDOWN:
## Fakta 
- Oppvaskmidler og tøymyknere er ikke miljøvennlige og kan forårsake kjemiske forurensninger som påvirker helsen vår.`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_energy_12: {
    title: 'Jeg reduserte behovet for å vaske klær i maskinen i dag',
    description:
      'Registreres hver dag du fjerner en flekk eller lufter et klesplagg framfor å vaske det i maskinen.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    biodiversity_explanation: `MARKDOWN:
## Fakta 
- Vask av tekstiler er en stor kilde til mikroplast. Det kan løsne så mye som 1900 mikroplastpartikler fra hvert eneste plagg i vask! Vi vasker klærne våre for ofte, så vurder om det holder med utlufting eller å tørke bort enkeltflekker. Det bidrar også til mindre slitasje på favorittplaggene dine, så du kan ha de lenger!

## Tilleggsinformasjon
- Les mer om mikroplast i Norge: [https://www.miljostatus.no/mikroplast](https://www.miljostatus.no/mikroplast)
- Les mer om mikroplast fra klær: [https://www.hioa.no/eng/About-HiOA/Centre-for-Welfare-and-Labour-Research/SIFO/Publications-from-SIFO/Microplastic-pollution-from-textiles-A-literature-review](https://www.hioa.no/eng/About-HiOA/Centre-for-Welfare-and-Labour-Research/SIFO/Publications-from-SIFO/Microplastic-pollution-from-textiles-A-literature-review)
- [https://link.springer.com/article/10.1007/s11356-017-0528-7#Sec3](https://link.springer.com/article/10.1007/s11356-017-0528-7#Sec3)`,
    handprint_explanation: `MARKDOWN:
## Fakta
Vi vasker klærene våre for ofte, noe som fører til store utslipp av mikroplast. Men hvis du går foran som et godt eksempel og viser at man enkelt kan redusere klesvasken ved å tørke bort en flekk, bidrar du kanskje til at andre også gjør det!

## Tips
- Tips til hvordan du kan vaske mer miljøvennlig: [https://www.framtiden.no/gronne-tips/fritid/kutting-av-mikroplast-fra-klesvask.html](https://www.framtiden.no/gronne-tips/fritid/kutting-av-mikroplast-fra-klesvask.html) og [https://www.framtiden.no/gronne-tips/klar/miljobevisst-klesvask.html](https://www.framtiden.no/gronne-tips/klar/miljobevisst-klesvask.html)`,
  },
  activity_energy_13: {
    title: 'Jeg kjørte vaskemaskinen på lavere temperatur i dag',
    description:
      'Kan logges på dager du vanligvis ville brukt vaskemaskinen, men du reduserte temperaturen til 30 grader eller lavere',
    co2_explanation: `MARKDOWN:
## Fakta 
- Å vaske klær på 30 grader bruker ca. 40 % mindre strøm sammenlignet med høyere temperaturer. Om man vasker klær på 20 grader blir  energibruken redusert med 66 %.

## Hva vi antar
- Det antas at du kan spare rundt 40 % av det gjennomsnittlige energiforbruket til vaskemaskiner hvis du vasker klærne på lavere temperaturer.

## Tilleggsinformasjon
- [https://acecleanuk.co.uk/30-vs-40-washing-lower-temperature-make-difference/](https://acecleanuk.co.uk/30-vs-40-washing-lower-temperature-make-difference/)`,
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
};
